<template>
<div class="main-container">
    <div class="container-individual-data">
        <div class="container-title">
            <p>Total de datos de calidad del aire:</p>
            <p>Total de datos hidrometeorológicos:</p>
            <p>Total de datos de aguas subterráneas:</p>
        </div>
        <div class="container-data">
            <span> {{ air_quantity_data }}</span>
            <span> {{ hidro_quantity_data }}</span>
            <span> {{ water_quantity_data }}</span>
        </div>
    </div>

    <div class="container-total-data">
        <div class="container-title">
            <p>Total de datos ambientales:</p>
        </div>
        <div class="container-data">
            <span>{{ total_quantity_data }}</span> 
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import apiRoutes from '../../assets/js/api_routes'

export default {
    name: 'HomeStationsInformation',
    data(){
        return{
            air_quantity_data: "Cargando...",
            hidro_quantity_data: "Cargando...",
            water_quantity_data: "Cargando...",
            total_quantity_data: "Cargando...",
        }
    },
    methods: {
        getTotalData() {
            axios.post(apiRoutes.total_quantity_data, { token: localStorage.access_token }).then((resp) => {
            let total = 0;
            resp.data.forEach(({ bodega, cantidad }) => {
            switch (bodega) {
              case 'hidrometereologica':
                this.hidro_quantity_data = cantidad;
                break;
              case 'calidad_aire':
                this.air_quantity_data = cantidad;
                break;
              case 'aguas_subterraneas':
                this.water_quantity_data = cantidad;
                break;
            }
            total += parseInt(cantidad);
            });
            this.total_quantity_data = total;
            })
            .catch((err) => {
                console.error(err);
            });
        }
    },
    mounted(){
        this.getTotalData();
    }
}
</script>
<style scoped>
.main-container{
    margin-left: 7rem;
    display: flex;
    flex-direction: column;
}
.container-individual-data{
    margin-bottom: 0.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.container-total-data{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.container-title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}
.container-data{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}
p {
    margin-right: 5rem;
    font-size: 1.1rem;
    margin-bottom: 0;
}
.container-title p:last-child {
    margin-right: 0;
}
span {
    margin-right: 9rem;
    margin-left: 9rem;
    padding: 0.4rem 1rem 0.4rem 1rem;
    border-radius: 0.5rem;
    background-color: rgba(131, 155, 36, 0.904);
    color: white;
}
</style>